// These are the error message keys that are ignored and not shown to the application alert
export enum ExceptionDispatchError {
    ALGOLIA_INDEX_NOT_FOUND = 'oiv.error.indexInfoNotFound',
}
